import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../templates/Ui';
const StyledInput = styled.input `
    transition: all 300ms ease-in-out;
    padding: ${props => props.bordered ? '10px 15px 15px 15px' : '10px 0px 15px 0px'};
    background-color: white;
    border: none;
    border-bottom: 1px solid ${color.border.base};
    width: 100%;
    margin-top: auto;
    outline: none;
    font-size: 16px;
    font-weight: ${props => props.theme.input?.fontWeight};
    color: ${props => props.theme.primary.dark};
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:focus {
        border-bottom-color: transparent;

        ~ .focus-border {
            transform: scaleX(1);
        }
    }

    &:disabled:focus {
        background-color: ${color.border.base};

        ~ .focus-border {
            opacity: 0;
        }
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }

    &[type='date']::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
    }

    &[type='date'] {
        padding: 10px 0 13px 0;
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &[type='date']:focus,
    &[type='date']:valid:not(:empty) {
        font-weight: 600;
        color: ${props => props.theme.primary.base};
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    &::placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
        opacity: 1;
    }

    &:-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &::-ms-input-placeholder {
        color: rgba(41, 48, 87, 0.25);
        font-weight: 400;
    }

    &::-webkit-datetime-edit-year-field:not([aria-valuenow]) {
        color: rgba(41, 48, 87, 0.25);
    }

    &::-webkit-datetime-edit-month-field:not([aria-valuenow]) {
        color: rgba(41, 48, 87, 0.25);
    }

    &::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
        color: rgba(41, 48, 87, 0.25);
    }

    &:not([value='']):not(:focus) {
        font-weight: ${props => props.theme.input?.fontWeight};
        color: ${props => props.theme.primary.dark};
    }

    &:not([value='']):not(:focus):invalid {
        color: #d70e24;
    }

    &[value='0000-00-00']::-webkit-datetime-edit {
        color: transparent;
    }
`;
const Input = props => _jsx(StyledInput, { ...props });
export default Input;
